<script lang="ts">
	import type { DataTypeInputProps, DataTypeInputValue } from "#lib/components/flow/editor/data-types/inputs/dataTypeInput.js";
	import EditImage from "#lib/components/images/EditImage.svelte";
	import type { ImagePickerChangeEvent } from "#lib/components/images/types.js";

	let { value = $bindable(), defaultValue, disabled = false, oninput, onchange }: DataTypeInputProps = $props();

	const image = $derived(value as ImagePickerChangeEvent | undefined);
	const defaultImage = $derived(defaultValue as ImagePickerChangeEvent | undefined);
	const displayImage = $derived(image ?? defaultImage);
	const showingDefault = $derived(image === undefined && defaultImage !== undefined);

	function handleChange(event: CustomEvent<ImagePickerChangeEvent>) {
		const { value: url, contentType, focalPoint } = event.detail;
		if (!url) {
			value = undefined;
		} else {
			const imageValue: { value: string; contentType: string | null; focalPoint?: { x: number; y: number } } = {
				value: url,
				contentType: contentType ?? null,
			};
			if (focalPoint && typeof focalPoint.x === "number" && typeof focalPoint.y === "number") {
				imageValue.focalPoint = { x: focalPoint.x, y: focalPoint.y };
			}
			value = imageValue;
		}
		const next: CustomEvent<DataTypeInputValue> = new CustomEvent(event.type, { detail: value ?? null });
		oninput?.(next);
		onchange?.(next);
	}
</script>

<div class="aspect-square h-full w-auto max-w-48" class:opacity-50={disabled} data-action-name="data-property-image">
	<EditImage class="size-full border-0 bg-transparent" {disabled} value={displayImage?.value} closeButton={!showingDefault} on:change={handleChange} />
</div>
